import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'aggregate',
  version: '1.1.0',
  properties: [
    {
      key: 'inputArray',
      label: 'Input Array',
      type: 'string',
      required: true,
      placeholder: '{{ $node["NodeName"].array }}',
      description: 'The array to aggregate. Drag from the input panel or type the path.',
    },
    {
      key: 'mode',
      label: 'Mode',
      type: 'options',
      required: true,
      default: 'aggregate',
      options: [
        { value: 'aggregate', name: 'Aggregate (Calculate)' },
        { value: 'merge', name: 'Merge (Combine Objects)' },
      ],
      description: 'Aggregate performs calculations; Merge combines all objects into one',
    },
    {
      key: 'aggregations',
      label: 'Aggregations',
      type: 'fixedCollection',
      required: true,
      typeOptions: {
        multipleValues: true,
      },
      default: {
        values: [],
      },
      displayOptions: {
        show: {
          mode: ['aggregate'],
        },
      },
      fixedCollectionOptions: [
        {
          name: 'values',
          displayName: 'Aggregation',
          values: [
            {
              key: 'field',
              label: 'Field',
              type: 'string',
              required: true,
              placeholder: 'amount',
              description: 'Field to aggregate',
            },
            {
              key: 'operation',
              label: 'Operation',
              type: 'options',
              required: true,
              default: 'sum',
              options: [
                { value: 'sum', name: 'Sum' },
                { value: 'avg', name: 'Average' },
                { value: 'min', name: 'Minimum' },
                { value: 'max', name: 'Maximum' },
                { value: 'count', name: 'Count' },
                { value: 'first', name: 'First Value' },
                { value: 'last', name: 'Last Value' },
                { value: 'concat', name: 'Concatenate' },
                { value: 'unique', name: 'Unique Values' },
                { value: 'collect', name: 'Collect All' },
              ],
            },
            {
              key: 'outputField',
              label: 'Output Field',
              type: 'string',
              required: true,
              placeholder: 'total',
              description: 'Name for the aggregated result',
            },
            {
              key: 'separator',
              label: 'Separator',
              type: 'string',
              default: ', ',
              placeholder: ', ',
              description: 'Separator for concatenation',
              displayOptions: {
                show: {
                  operation: ['concat'],
                },
              },
            },
          ],
        },
      ],
    },
    {
      key: 'groupBy',
      label: 'Group By',
      type: 'string',
      placeholder: 'category',
      description: 'Field to group by (leave empty to aggregate all items)',
      displayOptions: {
        show: {
          mode: ['aggregate'],
        },
      },
    },
  ],
};

export default schema;
